import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetInsurDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INSUR_DETAILS, token);
  return res;
};

export const GetInsur = async (insurId) => {
  const token = localStorage.getItem("token");
  const params = { insurId };

  // return axios.get(`${config.API_URL}/api/ACGInsur/GetInsur`, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${token}`,
  //   },
  //   params,
  // });
};

export const AddInsur = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_INSUR, payload, token);
  return res;
};

export const DeleteInsur = async (insurId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_INSUR + insurId,
    insurId,
    token
  );
  return res;
};

export const UpdateInsur = async (insurId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_INSUR + insurId, payload, token);
  return res;
};
